import { fromJS } from 'immutable';

import {
  REQUEST_LEADS_OVERVIEW,
  REQUEST_LEADS_OVERVIEW_SUCCESS,
  REQUEST_LEADS_OVERVIEW_FAILURE,
} from './types';

const initialState = fromJS({
  data: false,
  network: { loading: false, error: false },
});

export function leadsOverviewRequest() {
  return {
    type: REQUEST_LEADS_OVERVIEW,
  };
}

export function leadsOverviewSuccess(response) {
  return {
    type: REQUEST_LEADS_OVERVIEW_SUCCESS,
    response,
  };
}

export function leadsOverviewFailure(error) {
  return {
    type: REQUEST_LEADS_OVERVIEW_FAILURE,
    error,
  };
}

export default function leadsOverviewReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_LEADS_OVERVIEW:
      return state.setIn(['network', 'loading'], true);
    case REQUEST_LEADS_OVERVIEW_SUCCESS:
      return state.withMutations((s) =>
        s
          .setIn(['network', 'loading'], false)
          .setIn(['network', 'error'], false)
          .set('data', fromJS(action.response)),
      );
    case REQUEST_LEADS_OVERVIEW_FAILURE:
      return state.withMutations((s) =>
        s
          .setIn(['network', 'loading'], false)
          .setIn(['network', 'error'], action.error)
          .set('data', false),
      );
    default:
      return state;
  }
}
